import { get, post, put } from '../../api';
import { ansiToMoment, timeToMoment } from '@utils';

export const getTarefas = (idConfiguracao, idFonteDado) => {
  return get(`/api/conectores/tarefas/${idConfiguracao}/${idFonteDado}`);
};

export const getTarefa = async (idConfiguracao, idFonteDado, id) => {
  const res = await get(`/api/conectores/tarefa/${idConfiguracao}/${idFonteDado}/${id}`);

  // eslint-disable-next-line
  res.map((tarefa) => {
    tarefa.periodoDtExecucao = [ansiToMoment(tarefa.dtInicioExecucao), ansiToMoment(tarefa.dtFimExecucao)];
    tarefa.dtInicioExecucao = undefined;
    tarefa.dtFimExecucao = undefined;
    tarefa.periodoHrExecucao = [timeToMoment(tarefa.hrInicioExecucao), timeToMoment(tarefa.hrFimExecucao)];
    tarefa.hrInicioExecucao = undefined;
    tarefa.hrFimExecucao = undefined;
    tarefa.dtUltimaExecucao = ansiToMoment(tarefa.dtUltimaExecucao);
    tarefa.dtExecucao = ansiToMoment(tarefa.dtExecucao);
    tarefa.hrExecucao = timeToMoment(tarefa.hrExecucao);
  });

  return res;
};

export const postTarefa = (data) => {
  return post('/api/conectores/tarefa', data);
};

export const putTarefa = (data) => {
  return put('/api/conectores/tarefa', data);
};
